module.exports = __webpack_public_path__ + "static/020-0d52a30bf121e380c36410452134544d.png";